import {
  Box,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Typography,
  Tooltip,
  LinearProgress,
  // MenuItem,
  Autocomplete,
} from "@mui/material";
import { useRef, useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  deleteDiscourseInDatabase,
  updateDiscourse,
  getDiscourse,
  addDiscourse,
  getDiscourseTypes,
  getDiscourseByType,
  // getOrphanedWebpMetadata
} from "../../../services/database/database_service";
import DeleteIcon from "@mui/icons-material/Delete";
import areArraysEqual from "../../../utils/are_arrays_equal";
import { AppwriteException } from "appwrite";
import ProgressIndicator from "../../../common/widget/progress_indicator";
import CustomAlert from "../../../common/widget/custom_alert";
import SearchIcon from "@mui/icons-material/Search";

const DiscourseDataTableScreen = () => {
  const [rows, setRows] = useState([]);
  const [rowsToUpdate, setRowsToUpdate] = useState([]);
  // const [selectedRow, setSelectedRow] = useState({});
  const rowsBackup = useRef([]);
  const [showSaveBtn, setShowSaveBtn] = useState(false);

  const [alert, setAlert] = useState({
    show: false,
    severity: "info",
    msg: "",
  });

  const [alert2, setAlert2] = useState({
    show: false,
    severity: "info",
    msg: "",
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [discourse, setDiscourse] = useState({
    discourseTitle: "",
    discourseUrl: "",
    discourseDescription: "",
    discourseType: "",
  });

  // console.log("Discourse data: ", discourse);

  const [discourseTypes, setDiscourseTypes] = useState([]);
  const selectedDiscourseTypeRef = useRef("");

  const [isLoadingData, setIsLoadingData] = useState(false);
  const [showProgressIndicator, setShowProgressIndicator] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // delete dialog box
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const columns = [
    // story Title
    {
      field: "discourseTitle",
      headerName: "Discourse Title",
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      editable: true,
      renderHeader: (params) => <strong>Title</strong>,
    },
    // story Url
    {
      field: "discourseUrl",
      headerName: "Discourse URL",
      headerClassName: "super-app-theme--header",
      flex: 1,
      editable: true,
      renderHeader: (params) => <strong>Url</strong>,
    },
    // story description
    {
      field: "discourseDescription",
      headerName: "Discourse URL",
      headerClassName: "super-app-theme--header",
      flex: 1,
      editable: true,
      renderHeader: (params) => <strong>Description</strong>,
    },
    // story type
    {
      field: "discourseType",
      headerName: "Discourse Type",
      headerClassName: "super-app-theme--header",
      flex: 0.5,
      editable: false,
      renderHeader: (params) => <strong>Type</strong>,
      renderCell: (params) => (
        <Box
          sx={{
            textOverflow: "ellipsis",
            overflow: "auto",
            whiteSpace: "normal",
          }}
        >
          <Typography>{params.row.discourseType}</Typography>
        </Box>
      ),
    },

    // Delete
    {
      field: "delete",
      headerName: "Delete",
      headerClassName: "super-app-theme--header",
      flex: 0.5,
      renderCell: (params) => (
        <Tooltip title="Delete from database">
          <IconButton
            aria-label="delete"
            size="small"
            onClick={() => {
              setRowToDelete(params);
              setDeleteDialogOpen(true);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ),
      renderHeader: (params) => <strong>Delete</strong>,
    },
  ];

  const handleChange = (e) => {
    setDiscourse({
      ...discourse,
      [e.target.name]: e.target.value,
    });
  };

  const fetchDiscourse = async () => {
    setRows([]);
    setIsLoadingData(true);
    setAlert({ ...alert, show: false });
    await getDiscourse().then(
      (response) => {
        setRows(response.documents);
        rowsBackup.current = response.documents;
        if (response.total === 0) {
          setAlert({
            show: true,
            severity: "info",
            msg: "No content(s) found",
          });
        }
      },
      (error) => {
        setAlert({
          show: true,
          severity: "error",
          msg:
            error.response?.message ??
            "Could not fetch discourse data. Please try again later.",
        });
      }
    );
    await getDiscourseTypes().then((response) => {
      const documents = response.documents;
      let tmpCategory = [];
      for (const doc of documents) {
        tmpCategory.push(doc.discourseTypeName);
      }
      setDiscourseTypes(tmpCategory);
    });
    setIsLoadingData(false);
  };

  const fetchDiscourseByType = async () => {
    setRows([]);
    setIsLoadingData(true);
    setAlert({ ...alert, show: false });
    await getDiscourseByType(selectedDiscourseTypeRef.current).then(
      (response) => {
        setRows(response.documents);
        rowsBackup.current = response.documents;
        if (response.total === 0) {
          setAlert({
            show: true,
            severity: "info",
            msg: "No content(s) found",
          });
        }
      },
      (error) => {
        setAlert({
          show: true,
          severity: "error",
          msg:
            error.response?.message ??
            "Could not fetch discourse data. Please try again later.",
        });
      }
    );
    setIsLoadingData(false);
  };

  const initializeDiscourseType = async () => {
    await getDiscourseTypes().then((response) => {
      const documents = response.documents;
      let tmpCategory = [];
      for (const doc of documents) {
        tmpCategory.push(doc.discourseTypeName);
      }
      setDiscourseTypes(tmpCategory);
    }).catch((error) => {
         setAlert({
          show: true,
          severity: "error",
          msg: `Network error. Failed to fetch discourse types, please try again later.`,
        });
    });
  };


  
  const handleAddDiscourse = async () => {
    if (
      !discourse.discourseTitle.trim() ||
      !discourse.discourseUrl.trim() ||
      !discourse.discourseDescription.trim() ||
      !discourse.discourseType
    ) {
      setAlert2({
        show: true,
        severity: "warning",
        msg: "All fields are required!",
      });
      return;
    }
    setIsSubmitting(true);
    try {
      await addDiscourse(discourse); // Use the state object directly
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setOpenDialog(false);
      setDiscourse({
        discourseTitle: "",
        discourseUrl: "",
        discourseDescription: "",
        discourseType: "",
      });
      setAlert2("");

      // await fetchDiscourse();
      selectedDiscourseTypeRef.current = discourse.discourseType;
      await fetchDiscourseByType();
      setAlert({
        show: true,
        severity: "success",
        msg: "Discourse added successfully",
      });
    } catch (error) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setAlert2({
        show: true,
        severity: "error",
        msg: `${error.message}`,
      });
    }
    setIsSubmitting(false);
  };

  const handleUpdate = async () => {
    setAlert({ ...alert, show: false });
    setShowProgressIndicator(true);

    try {
      await updateDiscourse(rowsToUpdate);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setAlert({
        show: true,
        severity: "success",
        msg: "Updated successfully",
      });
      setShowSaveBtn(false);
    } catch (error) {
      let msg = error.message || "Unknown error during update";

      // Handle uniqueness error more clearly
      if (msg.toLowerCase().includes("duplicate title")) {
        msg = `Update failed: ${msg}`;
      }

      setAlert({
        show: true,
        severity: "error",
        msg,
      });
    }

    setShowProgressIndicator(false);
  };

  const handleDelete = async (params) => {
    setShowProgressIndicator(true);
    setAlert({ ...alert, show: false });

    deleteDiscourseInDatabase(params.row).then(
      async (response) => {
        if (response instanceof AppwriteException) {
          setAlert({
            show: true,
            severity: "error",
            msg: response.response.message,
          });
        } else {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          removeSingleRow(params.row);
          setAlert({
            show: true,
            severity: "success",
            msg: "Data deleted successfully",
          });
        }

        setShowProgressIndicator(false);
      },
      (error) => {
        setAlert({ show: true, severity: "error", msg: error });
      }
    );
  };

  const removeSingleRow = (params) => {
    const newRows = rows.filter(
      (row) => row.discourseTitle !== params.discourseTitle
    );
    setRows(newRows);
  };

  function onCellEditStop(params, event) {
    if (event?.target?.value) {
      const newRow = { ...params.row, [params.field]: event.target.value };
      let exist = false;
      let tmpRowsToUpdate = [...rowsToUpdate];
      let count = 0;
      // check if it exists in rowsToUpdate
      for (let r of rowsToUpdate) {
        if (params.id === r.$id) {
          exist = true;
          tmpRowsToUpdate[count] = newRow;
          setRowsToUpdate(tmpRowsToUpdate);
          setShowSaveBtn(true);
          break;
        }
        count++;
      }
      // if doesn't exist then append to list
      if (!exist) {
        tmpRowsToUpdate.push(newRow);
        setRowsToUpdate(tmpRowsToUpdate);
        setShowSaveBtn(true);
      }
    }
  }

  function CustomLinearProgress() {
    return (
      <LinearProgress
        style={{ backgroundColor: "white" }} // Change the background color to purple
        color="secondary" // Change the color to secondary (the color you want)
      />
    );
  }



  useEffect(() => {
    const result = areArraysEqual(rowsBackup.current, rows);
    if (!result) {
      setShowSaveBtn(true);
    } else {
      setShowSaveBtn(false);
    }
  }, [rows, rowsBackup]);

  useEffect(() => {
    // fetchDiscourseByType();
    initializeDiscourseType();
  }, []);

  return (
    <Box p={3} width={"100%"}>
      {/* alert */}
      <CustomAlert alert={alert} setAlert={setAlert} />

      <Box sx={{ display: "flex" }} gap={1}>
        <Autocomplete
          options={discourseTypes}
          sx={{ width: 300 }}
          onChange={(e, newValue) =>
            (selectedDiscourseTypeRef.current = newValue)
          }
          renderInput={(params) => (
            <Box display={"flex"} alignItems={"center"} gap={1}>
              <TextField
                {...params}
                label="Discourse Type"
                size="small"
                required
                onChange={(e) =>
                  (selectedDiscourseTypeRef.current = e.target.value)
                }
              />
              <IconButton onClick={fetchDiscourseByType}>
                <SearchIcon />
              </IconButton>
            </Box>
          )}
        />

        <Button
          variant="outlined"
          onClick={() => setOpenDialog(true)}
          sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
        >
          Add Discourse
        </Button>

        {/* Add Discourse form */}
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>
            <Typography align="center">
              <strong>Discourse</strong>
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ width: 500, maxWidth: "100%", ml: 1, mr: 1, mt: 1 }}>
              <CustomAlert alert={alert2} setAlert={setAlert2} />
            </Box>
            <Box sx={{ width: 500, maxWidth: "100%", ml: 1, mr: 1 }}>
              <TextField
                fullWidth
                label="Title"
                name="discourseTitle"
                value={discourse.discourseTitle}
                onChange={handleChange}
                required
                id="discourseTitle"
              />
            </Box>

            <Box sx={{ width: 500, maxWidth: "100%", m: 1 }}>
              <TextField
                fullWidth
                label="Video Url"
                name="discourseUrl"
                value={discourse.discourseUrl}
                onChange={handleChange}
                required
                id="discourseUrl"
              />
            </Box>

            <Box sx={{ width: 500, maxWidth: "100%", m: 1 }}>
              <TextField
                fullWidth
                label="Description"
                name="discourseDescription"
                multiline
                rows={3}
                value={discourse.discourseDescription}
                onChange={handleChange}
                required
                id="discourseDescription"
              />
            </Box>

            {/* <Box sx={{ width: 500, maxWidth: "100%", m: 1 }}>
              <TextField
                select
                fullWidth
                label="Type"
                name="discourseType"
                value={discourse.discourseType}
                onChange={handleChange}
                required
                id="discourseType"
              >
                <MenuItem value="story">Story</MenuItem>
                <MenuItem value="phrase">Phrase</MenuItem>
                <MenuItem value="sentence">Sentence</MenuItem>
              </TextField>
            </Box> */}

            {/* new drop down */}
            {/* <Typography
              sx={{ width: 500, maxWidth: "100%", mt: 1, ml: 1, mr: 1 }}
            >
              Select Type
            </Typography>
            <Autocomplete
              sx={{ width: 500, maxWidth: "100%", mt: 0, ml: 1, mr: 1 }}
              options={discourseTypes}
              onInputChange={(event, newInputValue) => {
                setDiscourse({
                  ...discourse,
                  discourseType: newInputValue,
                });
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            /> */}



          <Autocomplete
          options={discourseTypes}
          sx={{ width: 500, maxWidth: "100%", mt: 0, ml: 1, mr: 1 }}
          onChange={(e, newValue) =>
            // (selectedDiscourseTypeRef.current = newValue)
            {
                    setDiscourse({
                      ...discourse,
                      discourseType: newValue,
                    });
                  }
          }
          renderInput={(params) => (
            <Box display={"flex"} alignItems={"center"} gap={1}>
              <TextField
                {...params}
                label="Discourse Type"
                size="small"
                required
                onChange={(e) =>
                  // (selectedDiscourseTypeRef.current = e.target.value)
                  {
                    setDiscourse({
                      ...discourse,
                      discourseType: e.target.value,
                    });
                  }
                }
              />
            </Box>
          )}
        />
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb: 1 }}
              color="primary"
              onClick={handleAddDiscourse}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>

            <Button
              variant="outlined"
              color="error"
              // style={{ color: "red" }}
              sx={{
                boxShadow: "0px 2px 4px rgba(250, 6, 6, 0.1)",
                mb: 1,
                mr: 1,
              }}
              onClick={() => {
                setOpenDialog(false);
                setAlert2("");
                setDiscourse({
                  discourseTitle: "",
                  discourseUrl: "",
                  discourseDescription: "",
                  discourseType: "",
                });
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {showSaveBtn && rowsToUpdate.length > 0 && (
          <Button
            variant="outlined"
            size="small"
            onClick={handleUpdate}
            sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}
          >
            Update
          </Button>
        )}
      </Box>

      <Typography sx={{ marginTop: 1, marginBottom: 1 }}>
        Total: {rows.length}
      </Typography>

      {/* data grid */}
      <Box
        sx={{
          height: "70vh",
          width: "100%",
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
          "& .super-app-theme--header": {
            backgroundColor: "#ebdcfa",
          },
        }}
      >
        <DataGrid
          getRowId={(row) => row.$id}
          rows={rows}
          columns={columns}
          loading={isLoadingData}
          slots={{
            loadingOverlay: CustomLinearProgress,
          }}
          onCellEditStop={onCellEditStop}
        />
      </Box>

      {/* delete dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        aria-labelledby="confirm-delete-data"
      >
        <DialogTitle id="confirm-delete-data">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the discourse: "
            <strong>{rowToDelete?.row?.discourseTitle}</strong>" ? This action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteDialogOpen(false)}
            color="primary"
            variant="outlined"
            sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb: 1 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setDeleteDialogOpen(false);
              handleDelete(rowToDelete);
            }}
            variant="outlined"
            sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", mb: 1 }}
            color="error"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* process indicator */}
      <ProgressIndicator show={showProgressIndicator} />
    </Box>
  );
};
export default DiscourseDataTableScreen;
